module.exports = __webpack_public_path__ + "static/media/next-control-carousel-inactive.c4c24b22.svg";